import React from 'react'

export const scrollToElement = (
  element: React.RefObject<HTMLElement>,
  scrollTarget?: number,
  adjustment?: number,
) => {
  if (!document || !element.current) {
    return
  }

  let scrollPosition =
    scrollTarget || element.current.getBoundingClientRect().top + window.scrollY

  if (adjustment) {
    scrollPosition += adjustment
  }

  try {
    window.scrollTo({
      top: scrollPosition,
      behavior:
        'scrollBehavior' in document.documentElement.style ? 'smooth' : 'auto',
    })
  } catch {
    window.scrollTo(0, scrollPosition)
  }
}
